import { render, staticRenderFns } from "./HomeInPageSkeleton.vue?vue&type=template&id=7221a182&scoped=true&"
var script = {}
import style0 from "./HomeInPageSkeleton.vue?vue&type=style&index=0&id=7221a182&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7221a182",
  null
  
)

export default component.exports